import { createSlice } from '@reduxjs/toolkit'

const goPaySlice = createSlice({
    name: 'goPay',
    initialState: { open: false, actionUrl: null },
    reducers: {
        setOpen(state, action) {
            const { payload } = action

            state.open = payload
        },
        setActionUrl(state, action) {
            const { payload } = action

            state.actionUrl = payload
        },
    },
})

const { actions, reducer } = goPaySlice

export const { setOpen, setActionUrl } = actions

export default reducer
